import { useMemo, useState } from "react";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";
import useApi from "../../hooks/useApi";

const STATUS = ["DISPONÍVEL", "EM USO", "MANUTENÇÃO", "BAIXADO"];
const LOCAIS = ["TI", "ESCRITÓRIO", "OBRA A", "OBRA B", "ALMOXARIFADO", "OUTRO"];

export default function ModalNovoEquipamento({ onClose, onCreated, tiposAtivo }) {
  const api = useApi();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    id_tipo_ativo: "",
    descricao: "",
    patrimonio: "",
    serial: "",
    status: "DISPONÍVEL",
    local: "TI",
  });

  const canSubmit = useMemo(() => {
    return (
      Boolean(String(form.id_tipo_ativo || "").trim()) &&
      Boolean(form.descricao?.trim()) &&
      Boolean(form.patrimonio?.trim())
    );
  }, [form.descricao, form.id_tipo_ativo, form.patrimonio]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      if (name === "id_tipo_ativo") {
        return { ...prev, id_tipo_ativo: value };
      }
      return { ...prev, [name]: value.toUpperCase() };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setSaving(true);

      // Rota fictícia (backend você vai criar)
      await api.post("/Painel/API/InventarioTI/ativo/create.php", {
        id_tipo_ativo: form.id_tipo_ativo,
        descricao: form.descricao.trim().toUpperCase(),
        patrimonio: form.patrimonio.trim().toUpperCase(),
        serial: form.serial?.trim()?.toUpperCase() || null,
        status: form.status,
        local: form.local,
      });

      onClose?.();
      onCreated?.();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Overlay state={true}>
      <Modal header close={onClose} size="md">
        <Formulario onSubmit={handleSubmit}>
          <FormComp
            title="TIPO"
            type="select"
            options={(tiposAtivo ?? []).map((t) => ({ value: String(t.id), label: t.descricao }))}
            obj
            valor={String(form.id_tipo_ativo || "")}
            name="id_tipo_ativo"
            changeFunc={handleChange}
            required
          />
          <FormComp
            title="EQUIPAMENTO"
            type="text"
            placeholder="EX: DELL LATITUDE 5420"
            valor={form.descricao}
            name="descricao"
            changeFunc={handleChange}
            required
          />
          <FormComp
            title="PATRIMÔNIO"
            type="text"
            placeholder="EX: TI-10293"
            valor={form.patrimonio}
            name="patrimonio"
            changeFunc={handleChange}
            required
          />
          <FormComp
            title="SERIAL"
            type="text"
            placeholder="EX: SN-XXXXX"
            valor={form.serial}
            name="serial"
            changeFunc={handleChange}
          />
          <FormComp
            title="STATUS"
            type="select"
            options={STATUS}
            valor={form.status}
            name="status"
            changeFunc={handleChange}
            required
          />
          <FormComp
            title="LOCAL"
            type="select"
            options={LOCAIS}
            valor={form.local}
            name="local"
            changeFunc={handleChange}
            required
          />

          <FormComp
            type="submit"
            valor={saving ? "SALVANDO..." : "SALVAR"}
            disabled={saving || !canSubmit}
          />
        </Formulario>
      </Modal>
    </Overlay>
  );
}

